export const SliderData = [
    {
        image: 'https://res.cloudinary.com/joacocloud/image/upload/v1649370843/Eliabikes/cannondale-carrera_taxajr-min_khasjv.jpg',
        title: 'Road',
        url: 'category/road',
        cName: 'slider-title road'
    },
    {
        image: 'https://res.cloudinary.com/joacocloud/image/upload/v1649370841/Eliabikes/outdoor-bike_qymcm3-min_fozh0q.jpg',
        title: 'Mtb',
        url: 'category/mountain',
        cName: 'slider-title mountain'
    },
    {
        image: 'https://res.cloudinary.com/joacocloud/image/upload/v1649370845/Eliabikes/img-ni%C3%B1os-titulo_xfl38o-min_fka6oa.jpg',
        title: 'Niños',
        url: 'category/kids',
        cName: 'slider-title kids'
    },
    {
        image: 'https://res.cloudinary.com/joacocloud/image/upload/v1647924265/Eliabikes/girl-BW_goz0et.jpg',
        title: "Women's",
        url: 'category/womens',
        cName: 'slider-title womens'
    },
    {
        image: 'https://res.cloudinary.com/joacocloud/image/upload/v1649370842/Eliabikes/accesorios_wd0oap-min_mungu4.jpg',
        title: 'Repuestos',
        url: 'category/accesory',
        cName: 'slider-title accesory'
    }
]